import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function Badge({
  children,
  className,
  tone = "brand",
}: {
  children: ReactNode;
  className?: string;
  tone?: "brand" | "gold" | "neutral" | "outline";
}) {
  const tones = {
    brand: "bg-brand-600/10 text-brand-700",
    gold: "bg-gold-500/15 text-gold-700",
    neutral: "bg-ink/6 text-ink-soft",
    outline: "border border-line text-ink-soft",
  };
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wider",
        tones[tone],
        className
      )}
    >
      {children}
    </span>
  );
}

export function Eyebrow({
  children,
  className,
  center = false,
}: {
  children: ReactNode;
  className?: string;
  /** Mirror the gold rule on the right when the label sits above centered text. */
  center?: boolean;
  /** @deprecated Every section label now uses this one style; the prop is ignored. */
  kicker?: boolean;
}) {
  // One style for every section label across the site: gold rule + letterspaced brand-coloured caps.
  return (
    <span className={cn("inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.2em] text-brand-700", className)}>
      <span className="h-px w-8 bg-gold-400" aria-hidden />
      {children}
      {center && <span className="h-px w-8 bg-gold-400" aria-hidden />}
    </span>
  );
}
